// TODO: JSDOC
export enum EOrderFormType {
  SESSION_ORDER = 'SESSION_ORDER', // создание заявки на сессию клиентом
  PAYMENT_FORM = 'PAYMENT_FORM', // оплата созданной заявки клиентом
  CREATE_ORDER = 'CREATE_ORDER', // создание специалистом заявки на сессию, которую после оплатит клиент чере PAYMENT_FORM
}
